import {Component} from "@angular/core";

@Component({
    selector: "fui-tandem-field",
    styleUrls: ["./tandem-field.component.scss"],
    templateUrl: "./tandem-field.component.html"
})
export class FUITandemFieldComponent {
}
